import { Modal, Button } from "antd";
import { banFleetModelApi } from "api/fleetModel";
import WarningIcon from "components/Icons/WarningIcon";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { IFleetModel } from "models/fleetModel";
import { useState } from "react";

interface IProp {
  open: boolean;
  fleetModel: IFleetModel;
  handleClose: () => void;
}

export default function BanModal({ open, fleetModel, handleClose }: IProp) {
  const [loading, setLoading] = useState<boolean>(false);
  const { showError, showSuccess } = useNotificationContext();
  const { loadFleetModels } = useDataLoadingContext();

  const handleBan = async () => {
    setLoading(true);
    const { data, error } = await banFleetModelApi(fleetModel.id);
    if (data) {
      showSuccess("FleetModel banned successfully");
      loadFleetModels();
    } else showError(error!.message);
    setLoading(false);
    handleClose();
  };

  return (
    <Modal open={open} title={null} footer={null} closeIcon={null} centered>
      <div className="w-full text-center">
        <div className="w-full text-orange-400 text-9xl flex justify-center my-6">
          <WarningIcon />
        </div>
        <h3 className="text-3xl font-semibold my-4">Are you sure?</h3>
        <p
          className="font-normal text-base"
          style={{ color: "rgba(0,0,0,.64)" }}
        >
          You're about to ban {fleetModel.name}
        </p>
        <div className="w-full flex mt-7 items-center justify-end gap-x-3">
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleBan} loading={loading} type="primary" danger>
            Deactivate
          </Button>
        </div>
      </div>
    </Modal>
  );
}
